import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { SuppliersSchema } from 'Modules/Suppliers/Schemas/TherapySchema';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import {
  TherapySuppliersContext,
  defaultTherapyFilters,
} from 'Context/SuppliersContext/TherapySuppliersContext';
import { useContext } from 'react';

export const useTherapySuppliersForm = () => {
  const { filters } = useContext(TherapySuppliersContext);

  const therapySuppliersForm = useForm<ITherapySuppliers>({
    mode: 'all',
    resolver: yupResolver(SuppliersSchema),
    defaultValues: { ...defaultTherapyFilters, ...filters },
  });

  return {
    therapySuppliersForm,
  };
};
